/**
 * Функция вывода ошибки в консоль
 * @param error
 */
export const printErrors = (error: Error): void => {
  // eslint-disable-next-line no-console
  console.error(error);
};
